export {
  AnimatedPlaceholder,
  renderAnimatedPlaceholder_unstable,
  useAnimatedPlaceholder_unstable,
  animatedPlaceholderClassNames,
  useAnimatedPlaceholderStyles_unstable,
} from './components/AnimatedPlaceholder/index';
export type {
  AnimatedPlaceholderProps,
  AnimatedPlaceholderSlots,
  AnimatedPlaceholderState,
} from './components/AnimatedPlaceholder/index';
